module.exports = __webpack_public_path__ + "img/orthopedic-card-review.0d5363c1.png";